import React from "react";
import SubjectTopics from "../subjectTopics"; // Import the SubjectTopics component

// Probability Component
// This component renders a SubjectTopics component for the Probability subject
const Probability = () => <SubjectTopics subjectId={5} title="Probability" />;

export default Probability; // Export the Probability component
